import Radio from "backbone.radio";

import ModalFormLayout from "../generic/form-layout";
import Body from "./form-body";
import Buttons from "../generic/button/collection";
import buttons from "./form-buttons";

import InputClear from "../../behaviors/input-clear";

const channel = Radio.channel("global");

class FormBody extends ModalFormLayout {
  behaviors() {
    return [{ behaviorClass: InputClear }];
  }

  events() {
    return {
      submit: "_onSubmit",
    };
  }

  onBeforeShow() {
    // attach form fields
    this.body.show(
      new Body({
        model: this.model,
      })
    );

    // attach form buttons
    this.buttons.show(
      new Buttons({
        buttons,
        meta: this.options,
      })
    );
  }

  onShow() {
    this.triggerMethod("ContentRendered");
  }

  _onSubmit(e) {
    // prevent default behavior
    e.preventDefault();

    // prepare sync callbacks
    this.listenToOnce(this.model, "sync", this._onModelSync);
    this.listenToOnce(this.model, "error", this._onModelSyncFailure);

    // persist model
    this.model.save();
  }

  _onModelSync() {
    // dismiss the parent modal
    this.triggerMethod("dismiss:modal");

    // display success message
    channel.trigger("status:show", {
      type: "success",
      message: "Your account details have been updated.",
    });
  }

  _onModelSyncFailure() {
    // dismiss the parent modal
    this.triggerMethod("dismiss:modal");

    // console.warn("[%s] Unable to update details.", xhr.status);

    // display error message
    channel.trigger("status:show", {
      autoDismiss: false,
      type: "danger",
      message:
        "Your account details could not be updated. Please try again later.",
    });
  }
}

export { FormBody as default };
